import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initAuth } from "./api";
import "./styles.css";

const root = createRoot(document.getElementById("root")!);

initAuth()
  .then(() => root.render(<StrictMode><App /></StrictMode>))
  .catch(() => root.render(
    <div className="wrap"><div className="panel empty">
      <strong>Sign-in is unavailable.</strong>
      <span className="muted">The identity server could not be reached. Check that Keycloak is running, then reload.</span>
    </div></div>,
  ));
